import React from 'react'
import { NavLink, useLocation } from 'react-router-dom'
import logo from '/logo.png'

// Icons (Inline SVG - Heroicons Outline)
const Icons = {
  Dashboard: () => (
    <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M3.75 6A2.25 2.25 0 016 3.75h2.25A2.25 2.25 0 0110.5 6v2.25a2.25 2.25 0 01-2.25 2.25H6a2.25 2.25 0 01-2.25-2.25V6zM3.75 15.75A2.25 2.25 0 016 13.5h2.25a2.25 2.25 0 012.25 2.25V18a2.25 2.25 0 01-2.25 2.25H6A2.25 2.25 0 013.75 18v-2.25zM13.5 6a2.25 2.25 0 012.25-2.25H18A2.25 2.25 0 0120.25 6v2.25A2.25 2.25 0 0118 10.5h-2.25a2.25 2.25 0 01-2.25-2.25V6zM13.5 15.75a2.25 2.25 0 012.25-2.25H18a2.25 2.25 0 012.25 2.25V18A2.25 2.25 0 0118 20.25h-2.25A2.25 2.25 0 0113.5 18v-2.25z" />
    </svg>
  ),
  Projects: () => (
    <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M2.25 12.75V12A2.25 2.25 0 014.5 9.75h15A2.25 2.25 0 0121.75 12v.75m-8.69-6.44l-2.12-2.12a1.5 1.5 0 00-1.061-.44H4.5A2.25 2.25 0 002.25 6v12a2.25 2.25 0 002.25 2.25h15A2.25 2.25 0 0021.75 18V9a2.25 2.25 0 00-2.25-2.25h-5.379a1.5 1.5 0 01-1.06-.44z" />
    </svg>
  ),
  BoQ: () => (
    <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z" />
    </svg>
  ),
  Schedule: () => (
    <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 012.25-2.25h13.5A2.25 2.25 0 0121 7.5v11.25m-18 0A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75m-18 0v-7.5A2.25 2.25 0 015.25 9h13.5A2.25 2.25 0 0121 11.25v7.5" />
    </svg>
  ),
  Cost: () => (
    <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M12 6v12m-3-2.818l.879.659c1.171.66 2.53.66 3.701 0l.879-.659a2.25 2.25 0 012.983 3.638 2.25 2.25 0 01-3.638-2.983 3.375 3.375 0 00-2.486-5.492 3.375 3.375 0 00-2.486 5.492 2.25 2.25 0 01-3.638 2.983 2.25 2.25 0 012.983-3.638l.879-.659z" />
    </svg>
  ),
  CurvaS: () => (
    <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M7.5 14.25v2.25m3-4.5v4.5m3-6.75v6.75m3-9v9M12 21a9 9 0 100-18 9 9 0 000 18z" />
    </svg>
  ),
  Tasks: () => (
    <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
    </svg>
  ),
  Settings: () => (
    <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M10.343 3.94c.09-.542.56-.94 1.11-.94h1.093c.55 0 1.02.398 1.11.94l.149.894c.07.424.384.764.78.93.398.164.855.142 1.205-.108l.737-.527a1.125 1.125 0 011.45.12l.773.774c.39.389.44 1.002.12 1.45l-.527.737c-.25.35-.272.806-.107 1.204.165.397.505.71.93.78l.893.15c.543.09.94.56.94 1.109v1.094c0 .55-.397 1.02-.94 1.11l-.894.149c-.424.07-.764.383-.929.78-.165.398-.143.854.107 1.204l.527.738c.32.447.269 1.06-.12 1.45l-.774.773a1.125 1.125 0 01-1.449.12l-.738-.527c-.35-.25-.806-.272-1.203-.107-.397.165-.71.505-.781.929l-.149.894c-.09.542-.56.94-1.11.94h-1.094c-.55 0-1.019-.398-1.11-.94l-.148-.894c-.071-.424-.384-.764-.781-.93-.398-.164-.854-.142-1.204.108l-.738.527c-.447.32-1.06.269-1.45-.12l-.773-.774a1.125 1.125 0 01-.12-1.45l.527-.737c.25-.35.273-.806.108-1.204-.165-.397-.505-.71-.93-.78l-.894-.15c-.542-.09-.94-.56-.94-1.109v-1.094c0-.55.398-1.02.94-1.11l.894-.149c.424-.07.765-.383.93-.78.165-.398.143-.854-.107-1.204l-.527-.738a1.125 1.125 0 01.12-1.45l.773-.773a1.125 1.125 0 011.45-.12l.737.527c.35.25.807.272 1.204.107.397-.165.71-.505.78-.929l.15-.894z" />
      <path strokeLinecap="round" strokeLinejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
    </svg>
  ),
  Logo: () => (
    <img src={logo} alt="Tunas Haruman Logo" className="w-8 h-8" />
  )
}

export const Sidebar: React.FC = () => {
  const location = useLocation()
  const pathname = location?.pathname || ''
  const currentProjectId = pathname.split('/')[2] || '1'

  const navigation = [
    { name: 'Dashboard', href: '/dashboard', icon: Icons.Dashboard },
    { name: 'Projects', href: '/', icon: Icons.Projects },
  ]

  const projectNavigation = [
    { name: 'BoQ & Estimating', href: `/projects/${currentProjectId}/boq`, icon: Icons.BoQ },
    { name: 'Schedule', href: `/projects/${currentProjectId}/schedule`, icon: Icons.Schedule },
    { name: 'Cost Control', href: `/projects/${currentProjectId}/cost`, icon: Icons.Cost },
    { name: 'Curva S', href: `/projects/${currentProjectId}/curva`, icon: Icons.CurvaS },
    { name: 'Tasks', href: `/projects/${currentProjectId}/tasks`, icon: Icons.Tasks },
  ]

  return (
    <div className="flex grow flex-col gap-y-5 overflow-y-auto bg-white px-4 pb-4 border-r border-slate-200 w-72 fixed inset-y-0 z-50 font-sans antialiased">
      {/* Brand Header */}
      <div className="flex h-16 shrink-0 items-center gap-3 mt-1">
        <Icons.Logo />
        <div className="flex flex-col">
          <span className="text-slate-900 font-bold text-base tracking-tight leading-none">Tunas Haruman</span>
          <span className="text-slate-500 text-[10px] font-medium tracking-wide mt-1">Project Management</span>
        </div>
      </div>
      
      <nav className="flex flex-1 flex-col">
        <ul role="list" className="flex flex-1 flex-col gap-y-7">
          
          {/* Main Menu */}
          <li>
            <div className="text-[10px] font-bold uppercase tracking-wider text-slate-400 px-3 mb-2">Main Menu</div>
            <ul role="list" className="space-y-1">
              {navigation.map((item) => (
                <li key={item.name}>
                  <NavLink
                    to={item.href}
                    className={({ isActive }) =>
                      `group flex gap-x-3 rounded-md px-3 py-2 text-sm font-medium transition-colors duration-200 ${
                        isActive
                          ? 'bg-slate-100 text-slate-900 [&>svg]:text-slate-900'
                          : 'text-slate-500 hover:text-slate-900 hover:bg-slate-50 [&>svg]:text-slate-400 group-hover:[&>svg]:text-slate-600'
                      }`
                    }
                  >
                    <item.icon />
                    {item.name}
                  </NavLink>
                </li>
              ))}
            </ul>
          </li>

          {/* Project Context */}
          <li>
            <div className="text-[10px] font-bold uppercase tracking-wider text-slate-400 px-3 mb-2 flex items-center justify-between">
              <span>Project Context</span>
              <span className="bg-slate-100 text-slate-600 text-[10px] px-1.5 py-0.5 rounded border border-slate-200 font-medium">ID: {currentProjectId}</span>
            </div>
            <ul role="list" className="space-y-1">
              {projectNavigation.map((item) => (
                <li key={item.name}>
                  <NavLink
                    to={item.href}
                    className={({ isActive }) =>
                      `group flex gap-x-3 rounded-md px-3 py-2 text-sm font-medium transition-colors duration-200 ${
                        isActive
                          ? 'bg-slate-100 text-slate-900 [&>svg]:text-primary-600'
                          : 'text-slate-500 hover:text-slate-900 hover:bg-slate-50 [&>svg]:text-slate-400 group-hover:[&>svg]:text-slate-600'
                      }`
                    }
                  >
                    <item.icon />
                    {item.name}
                  </NavLink>
                </li>
              ))}
            </ul>
          </li>

          {/* Bottom Profile */}
          <li className="mt-auto">
            <div className="rounded-xl border border-slate-200 p-3 bg-slate-50/50">
              <NavLink
                to="/settings"
                className="group flex gap-x-3 rounded-md p-1.5 text-xs font-medium text-slate-500 hover:text-slate-900 hover:bg-slate-100 transition-all mb-3 items-center"
              >
                <Icons.Settings />
                <span>Settings</span>
              </NavLink>
              
              <div className="flex items-center gap-x-3 pt-3 border-t border-slate-200">
                <div className="h-8 w-8 rounded-full bg-slate-200 flex items-center justify-center text-slate-600 font-bold text-xs ring-2 ring-white">
                  JD
                </div>
                <div className="flex flex-col">
                  <span className="text-xs font-semibold text-slate-900">John Doe</span>
                  <span className="text-[10px] text-slate-500">Project Manager</span>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </nav>
    </div>
  )
}
